import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { HeroUIProvider } from "@heroui/react";
import { App } from "./App_SparcliVisionHero";
import { loadAppConfig } from "./config/runtime";
import { Model3DDemo } from "./pages/Model3DDemo";
import sparcliLogo from "./assets/img/logo-neg.png";

/* ---------------- Landing Page ---------------- */

function Landing() {
    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                padding: "24px",
                background: "url('/assets/img/bg.png') center / cover no-repeat",
                color: "#ebe9ff",
                fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
            }}
        >
            <div
                style={{
                    width: "min(760px, 100%)",
                    borderRadius: "22px",
                    padding: "28px 30px",
                    border: "1px solid rgba(255,255,255,.16)",
                    background: "linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,.03))",
                    boxShadow: "0 20px 48px rgba(0,0,0,.45)",
                    backdropFilter: "blur(8px)",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "14px" }}>
                    <img src={sparcliLogo} alt="Sparcli" style={{ height: "30px", width: "auto" }} />
                    <h1 style={{ margin: 0, fontSize: "34px", letterSpacing: ".2px" }}>SparcliVision</h1>
                </div>

                <p style={{ margin: "8px 0", color: "rgba(235,233,255,.9)", fontSize: "17px", lineHeight: 1.5 }}>
                    SparcliVision aiuta a partire da un’idea astratta o da una visione e trasformarla in un progetto concreto.
                </p>
                <p style={{ margin: "8px 0", color: "rgba(235,233,255,.78)", fontSize: "16px", lineHeight: 1.5 }}>
                    Il percorso passa da un brief di ispirazione, a un brief tecnico strutturato con vincoli e obiettivi chiari.
                </p>
                <p style={{ margin: "8px 0", color: "rgba(235,233,255,.78)", fontSize: "16px", lineHeight: 1.5 }}>
                    Da lì genera immagini di vario tipo e conclude con la creazione e la visualizzazione del modello 3D finale.
                </p>
            </div>
        </div>
    );
}

/* ---------------- Create Project Redirect ---------------- */

function CreateProjectRedirect() {
    const nav = useNavigate();

    React.useEffect(() => {
        const id = uuidv4();
        nav(`/projects/${id}`, { replace: true });
    }, [nav]);

    return null;
}

/* ---------------- Bootstrap ---------------- */

async function bootstrap() {
    const cfg = await loadAppConfig();
    (window as any).__APP_CONFIG__ = cfg;

    ReactDOM.createRoot(document.getElementById("app")!).render(
        <React.StrictMode>
            <HeroUIProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/demo-3d" element={<Model3DDemo />} />
                        <Route path="/projects/create" element={<CreateProjectRedirect />} />
                        <Route path="/projects/:projectId" element={<App />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </HeroUIProvider>
        </React.StrictMode>
    );
}

bootstrap();
